module.exports = __webpack_public_path__ + "img/1_06.a9c3a8f0.jpg";